export const handleAuthError = (error) => {
    const path = window.location.pathname;
    if (path === '/login' || path === '/signup') {
        return false;
    }

    // Handle all 401 errors
    if (error?.response?.status === 401) {
        document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        window.location.replace('/login');
        return true;
    }

    // Keep existing network error handling
    if (error.message?.includes('Failed to fetch') || 
        error.message?.includes('Network Error')) {
        document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        window.location.replace('/login');
        return true;
    }

    return false;
};
